import React from 'react'
import WorkSummaryDetailViewJobAssignmentTableItem from './WorkSummaryDetailViewJobAssignmentTableItem'

export default ({ jobAssignments }) => (
  <div className="overflow-x-auto">
    <table className="w-full border-collapse">
      <thead>
        <tr className="bg-gray-100 border-b border-gray-200">
          <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">
            Service
          </th>
          <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">
            Passenger
          </th>
          <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">
            Time
          </th>
        </tr>
      </thead>
      <tbody className="divide-y divide-gray-200">
        {jobAssignments &&
          jobAssignments.map((jobAssignment) => (
            <WorkSummaryDetailViewJobAssignmentTableItem
              key={jobAssignment._id}
              jobAssignment={jobAssignment}
            />
          ))}
      </tbody>
    </table>
  </div>
)
